import Content from "../common/Content";
import Footer from "../common/Footer";
import Header from "../common/Header";
import DataTable from "react-data-table-component";
import { API } from "../../helper/Api";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import $ from "jquery";
import SessionHandler from "../common/SessionHandler";
import { useRole } from "../contextApi/RoleContext";
import { useLocation,Link, useNavigate } from "react-router-dom";


export default function SalesReport() {

  const [items, setItems] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);
  const [pending, setPending] = useState(true);
  const [storeCode, setStoreCode] = useState([]);

  const location = useLocation();
  const API_URL = process.env.REACT_APP_BASE_URL;

  const queryParams = new URLSearchParams(location.search);
  const store = queryParams.get('store');
  const fromDate = queryParams.get('fromDate');
  const toDate = queryParams.get('toDate');

  let formdate = new Date(fromDate);
  let todate = new Date(toDate);
/* Date format you have */
let fromdateMDY = `${(formdate.getMonth() + 1).toString().padStart(2, '0')}${formdate.getDate().toString().padStart(2, '0')}${formdate.getFullYear()}`;
let todateMDY = `${(todate.getMonth() + 1).toString().padStart(2, '0')}${todate.getDate().toString().padStart(2, '0')}${todate.getFullYear()}`;
console.log(formdate);

const fromYear = formdate.getFullYear();
const toYear = todate.getFullYear();

//const lowestYear = (Math.min(fromYear, toYear))-1;





/* Date converted to MM-DD-YYYY format */

  useEffect(() => {
    salesReceiptLists();
    fetchStoreCode();
  }, []);

 /////convert the time into US format 

const dateConvert = (dateString)=>{
  const date = new Date(dateString);

   // Format the date as MM/DD/YYYY
   const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-indexed
   const day = date.getDate().toString().padStart(2, '0');
   const year = date.getFullYear();
 
   // Format the time as hh:mm AM/PM
   let hours = date.getHours();
   const minutes = date.getMinutes().toString().padStart(2, '0');
   const isAM = hours < 12;
   
   // Convert to 12-hour format
   hours = hours % 12 || 12; // The hour 0 should be 12 in 12-hour format
   const period = isAM ? 'AM' : 'PM';
 
   return `${month}/${day}/${year}`;

}

 const formatDate = (dateString) => {
  const date = new Date(dateString);
  
  // Format the date as MM/DD/YYYY
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-indexed
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  // Format the time as hh:mm AM/PM
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const isAM = hours < 12;
  
  // Convert to 12-hour format
  hours = hours % 12 || 12; // The hour 0 should be 12 in 12-hour format
  const period = isAM ? 'AM' : 'PM';

  return `${month}/${day}/${year} ${hours}:${minutes} ${period}`;
};

  ///get the store code /////
  const fetchStoreCode = async () => {
    try {
      const res = await fetch(`${API_URL}location.php`);
      // Check if the response is successful (status 200)
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await res.json();
      console.log(result)
      const extractCode = result.ApiDocument.Response.Locations.map(
        (item) => {
          return { code: item.Code,name: item.Name };
        }
      ).filter((item) => item.code == store);
      setStoreCode(extractCode);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
//////end////////////////////////


  const salesReceiptLists = () => {
    setPending(true);

    API.getSalesOrderRecipts({fromdateMDY,todateMDY,store})
      .then((datas) => {
         setItemDetails(datas);
         setPending(false);

      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    

      $("#salesReportTable").DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 25,
        responsive: true,
        colReorder: true,
        autoWidth: false,
        destroy: true,
        stateSave: true,
        layout: {
          topStart: {
            buttons: [
              "copy",
              "csv",
              "excel",
              "pdf",
              "print",
              {
                extend: "colvis",
                collectionLayout: "fixed columns",
                popoverTitle: "",
              },
            ],
          },
        },
      });



  }, [itemDetails]);


  return (
    <>
    <div className="container-fluid page-body-wrapper">
      <div className="main-panel">
        <div className="content-wrapper">

            <div class="Card_contend">

              {pending ? (
                <div className="loader">
                  <RotatingLines
                    visible={true}
                    height="96"
                    width="96"
                    strokeColor="grey"
                    strokeWidth="2"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                  />
                </div>
              ) : (
                <div class="table-responsive">


                <div class="date_range">
                <h2>Period Sales By Item For {storeCode.length > 0 ? storeCode[0]['name'] : ""}</h2>

                  <p>Date Range : {dateConvert(fromDate)} to {dateConvert(toDate)}</p>

                </div>

                  {!pending ? (
                    <table id="salesReportTable" className="row-border">
                      <thead>
                      <tr>
                        <th colspan="5"></th>
                        <th colspan="3" style={{ textAlign: "center"}}>PERIOD YEAR</th>
                        <th colspan="3" style={{ textAlign: "center"}}>LAST PERIOD</th>
                        <th colspan="5"></th>
                      </tr>
                        <tr>
                          <th>ITEM#</th>
                          <th>DESCRIPTION</th>
                          <th>ST</th>
                          <th>COST</th>
                          <th>PRICE</th>
                          <th>PERIOD<br></br> SALES</th>
                          <th>PERIOD <br></br>QTY</th>
                          <th>PERIOD<br></br> GPP</th>
                          <th>SALES<br></br> LYR</th>
                          <th>QTY <br></br>LYR</th>
                          <th>GP<br></br> LYR</th>
                          <th>QTY<br></br>OH</th>
                          <th>QTY<br></br>OO</th>
                          <th>CAT#/<br></br>SUB#</th>
                          <th>NSO</th>
                          <th>LAST SOLD DATE</th>
                        </tr>
                      </thead>
                      <tbody>
                       {itemDetails.map((itemDetail) =>(
                          <tr>
                            <td>{itemDetail.itemNumber ? itemDetail.itemNumber : ""}</td>
                            <td>{itemDetail.itemDescription ? itemDetail.itemDescription : ""}</td>
                            <td>{itemDetail.ItemStatus ? itemDetail.ItemStatus : ""}</td>
                            <td>
                              {itemDetail.ItemCost 
                                ? itemDetail.ItemCost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                                : "$0.00"}
                            </td>                            
                            <td>
                              {itemDetail.ItemPrice 
                                ? itemDetail.ItemPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                                : "$0.00"}
                            </td> 
                            <td>
                              {itemDetail.TotalSales 
                                ? itemDetail.TotalSales.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                                : "$0.00"}
                            </td> 
                            <td>{itemDetail.TotalQtySold ? itemDetail.TotalQtySold : ""}</td>
                            <td>{itemDetail.GPPYTD ? (itemDetail.GPPYTD * 100).toFixed(2) : ""}%</td>

                            <td>
                              {itemDetail.TotalSalesYTDLYR 
                                ? itemDetail.TotalSalesYTDLYR.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                                : "$0.00"}
                            </td> 

                            <td>{itemDetail.TotalQtySoldLYR ? itemDetail.TotalQtySoldLYR : ""}</td>
                            <td>{itemDetail.GPPLYR ? (itemDetail.GPPLYR * 100).toFixed(2) : ""}%</td>
                            <td>{itemDetail.QtyOH ? itemDetail.QtyOH : ""}</td>
                            <td>{itemDetail.QtyOO ? itemDetail.QtyOO : ""}</td>
                            <td>{itemDetail.CategoryID ? itemDetail.CategoryID : ""}</td>
                            <td style={{textAlign: "center"}}>
                            {itemDetail.NSOItem == 'Y' ? (
                                <span class="mdi mdi-checkbox-marked-circle nso_true" style={{fontSize: "25px"}}></span>
                              ) : <span class="disableNSO">N</span>}
                              </td>
                            <td>{itemDetail.LastSoldDate ? formatDate(itemDetail.LastSoldDate) : ""}</td>
                          </tr>
                          ))}
                      </tbody>
                    </table>
                  ) : 
                  null}
                </div>
              )}
            </div>


        </div>
      </div>
    </div>
    </>
  )
}
